define('viewmodels/AMLRiskAssessment',['plugins/router', 'knockout', 'services/appsecurity', 'services/navigation', 'services/logger', 'durandal/app'], function (router, ko, appsecurity, navigation, logger, app) {
    var childRouter = router.createChildRouter()
        .makeRelative({
            //moduleId: 'viewmodels',
            fromParent: true
        }).map([
            { route: ['', 'AMLInherentRiskAssessment'], moduleId: 'viewmodels/AMLRiskAssessment/AMLInherentRiskAssessment', title: 'AML Inherent Risk Assessment', type: 'list', hash: '#AMLRiskAssessment/AMLInherentRiskAssessment', nav: true, settings: { caption: 'fa fa-th', another: 'property' } },
            { route: 'AMLControlRiskAssessment', moduleId: 'viewmodels/AMLRiskAssessment/AMLControlRiskAssessment', title: 'AML Controls Assessment', type: 'list', hash: '#AMLRiskAssessment/AMLControlRiskAssessment', nav: true, settings: { caption: 'fa fa-th', another: 'property' } },
            { route: ['', 'RAInherentReport'], moduleId: 'viewmodels/reporting/RAInherentReport', title: 'AML Inherent Risk Assessment', type: 'list', hash: '#AMLRiskAssessment/RAInherentReport', nav: true, settings: { caption: 'fa fa-th', another: 'property' } },
            { route: ['', 'RAControlsReport'], moduleId: 'viewmodels/reporting/RAControlsReport', title: 'AML Controls Risk Assessment', type: 'list', hash: '#AMLRiskAssessment/RAControlsReport', nav: true, settings: { caption: 'fa fa-th', another: 'property' } },

        ]).buildNavigationModel();

    return {
        navigation: navigation,
        router: childRouter,
        activate: activate,
        attached: attached,
        detached: detached,
        navigateAMLInherentRiskAssessment: navigateAMLInherentRiskAssessment,
        navigateAMLControlRiskAssessment: navigateAMLControlRiskAssessment,
        logger: logger,

        appsecurity: appsecurity,


        settingOptions: ko.computed(function () {
            return ko.utils.arrayFilter(childRouter.navigationModel(), function (route) {
                return route.type == 'list';
            });
        })

    };


    function navigateAMLInherentRiskAssessment() {
        try {
            router.navigate("AMLRiskAssessment/AMLInherentRiskAssessment", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateAMLInherentRiskAssessment()  in AMLRiskAssessment.js';
            logger.logMessage(msg);
        }
    }
    function navigateAMLControlRiskAssessment() {
        try {
            router.navigate("AMLRiskAssessment/AMLControlRiskAssessment", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateAMLInherentRiskAssessment()  in AMLRiskAssessment.js';
            logger.logMessage(msg);
        }
    }


    function activate() {
    }


    function detached() {
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).removeClass('active');
    };

    function attached() {
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).addClass('active');
    }
});





